// import http from '../request/http';
import {Message} from 'element-ui';
import router from '../router/index';
import {
    logout,
    getUserInfo,
    getCollectSchool,
    removeCollectSchool,
    removeCollectSchoolList,
    getSchoosFinder
  } from "../api/index";
  import {
    USER_INFO,
    RESET_USER_INFO,
    INIT_USER_INFO,
    USER_COLLECT_SCHOOL,
    REMOVE_COLLECT_SCHOOL,
    SCHOOL_FINDER_DATA,
    INIT_SCHOOL__DATA,
    SAVE_TOTAL_SACORE,
    REMOVE_COLLECT_SCHOOL_ALL
  } from "./mutation-types";
import {apiFlag} from "../common/commonVariable";
import { clearAllPage, logOutHandleStorage } from '../common/loginout';
import { param } from 'jquery';
let module={};
// 1为线上版本，2为本地版本
let http={};
async function getApiIndexMethod(){
    const flag=apiFlag;
    if(flag===1||flag===3){
      module=await import("../api/index");
      http=await import("../request/http");
    }else if(flag===2){
      module=await import("../api/index22");
      http=await import("../request/http11");
    }
}
getApiIndexMethod();
export default{
// 保存token令牌
saveToken({commit},token){
    commit("saveToken",{token});
},
// 保存用户信息
saveUserInfo({commit},userInfo){
    commit("saveUserInfo",{userInfo});
},
saveUserName({commit},userName){
    commit('saveUserName',{userName});
},
saveUserPwd({commit},userPwd){
    commit('saveUserPwd',{userPwd});
},
initUserName({commit}){
    commit('initUserName');
},
initUserPwd({commit}){
    commit('initUserPwd');
},
saveCollectSchool({commit},{collectSchool,pc}){
    commit('saveCollectSchool',{collectSchool,pc});
},
saveLrzyfaList({commit},{lrzyfaList,pc}){
    commit('saveLrzyfaList',{lrzyfaList,pc});
},
saveCompareSchool({commit},{compareSchool}){
    commit("saveCompareSchool",{compareSchool});
},
initCompareSchool({commit}){
    commit("initCompareSchool");
},
// 院校查询
async getSchoolFind({commit},params){
    await getApiIndexMethod();
const res=await http.postHttp("/yxcx/selectYx",params.requestParam);
const type=params.requestParam.tqPcType?params.requestParam.tqPcType+'':null;
console.log(type);
if(res.data.code===200){
    const data=[...res.data.obj.records];
    const total=res.data.obj.total;
    const pageSize=res.data.obj.size;
    const pageNum=res.data.obj.current;
    for(let i=0;i<data.length;i++){
        if(data[i]){
            data[i].lx=type;
        }
    }
    commit("getSchoolFind",{schoolFindData:{data:{list:data,total:total,pageSize:pageSize,pageNum:pageNum}}});
}else if(res.data.code===500){
    if(res.data.message){
        Message.error({message:res.data.message});
    }else if(res.data.msg){
        Message.error({message:res.data.msg});
    }
    commit('initSchoolFind');
}else if(res.status===401){
    Message.error({message: '登录超时，请重新登录'});
    await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
    router.replace({
        path: '/main/home',
        query: {redirect: router.currentRoute.fullPath}
    });
}else if(res.data.code===0){
    Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
    await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
    router.replace({
        path: '/main/home',
        query: {redirect: router.currentRoute.fullPath}
    });
}else if(res.status===409||res.status===410||res.status===411){
    Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
    await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
    router.replace({
        path: '/main/home',
        query: {redirect: router.currentRoute.fullPath}
    });
}
},
// 院校推荐
async getRecommendYx({commit},params){
    await getApiIndexMethod();
    const res=await http.postHttp("/yxcx/yxtj",params.requestParam);
    if(res.data.code===200){
        const data=res.data.obj.records;
        const total=res.data.obj.total;
        const pageSize=res.data.obj.size;
        const pageNum=res.data.obj.current;
        commit("getRecommend",{recommendData:{data:{list:data,total:total,pageSize:pageSize,pageNum:pageNum}}});
    }else if(res.data.code===500){
        if(res.data.message){
            Message.error({message:res.data.message});
        }else if(res.data.msg){
            Message.error({message:res.data.msg});
        }
        commit('initRecommend');
    }else if(res.status===401){
        Message.error({message: '登录超时，请重新登录'});
        await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(res.data.code===0){
        Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
        await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(res.status===409||res.status===410||res.status===411){
        Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
        await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }
},
// 专业组推荐
async getRecommendZyz({commit},params){
    await getApiIndexMethod();
    const res=await http.postHttp("/yxZyzTj",params.requestParam);
    if(res.data.code===200){
        const data=[...res.data.obj.records];
        for(let i=0;i<data.length;i++){
            if(data[i].yxmc){
                data[i].isShowZyzDetail=false;
                data[i].isCanDisabled=false;
            }
        }
        console.log(data);
        const total=res.data.obj.total;
        const pageSize=res.data.obj.size;
        const pageNum=res.data.obj.current;
        commit("getRecommend",{recommendData:{data:{list:data,total:total,pageSize:pageSize,pageNum:pageNum}}});
    }else if(res.data.code===500){
        if(res.data.message){
            Message.error({message:res.data.message});
        }else if(res.data.msg){
            Message.error({message:res.data.msg});
        }
        commit('initRecommend');
    }else if(res.status===401){
        Message.error({message: '登录超时，请重新登录'});
        await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(res.data.code===0){
        Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
        await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(res.status===409||res.status===410||res.status===411){
        Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
        await this.dispatch('loginOut',{sjhm:this.state.userInfo.sjhm});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }
},
// 退出登录
async loginOut({commit},param){


    const sjhm=param.sjhm;
    localStorage.removeItem('whBkTableData');
    localStorage.removeItem('whZkTableData');
    localStorage.removeItem('pc');
    await getApiIndexMethod();
        const res=await http.getHttp("/login/logout?sjhm="+sjhm);
            //         function debounce(fn, delay, isImmediate) { 
            
            // var timer = null;  //初始化timer，作为计时清除依据
            // return function() { 
            
            //     var context = this;  //获取函数所在作用域this
            //     var args = arguments;  //取得传入参数
            //     clearTimeout(timer);
            //     if(isImmediate && timer === null) {
            //         //时间间隔外立即执行
            //         fn.apply(context,args);
            //     timer = 0;
            //     return;
            //     }
            //     timer = setTimeout(function() { 
            
            //     fn.apply(context,args);
            //     timer = null;
            //     }, delay);
            // }
            // }
            // let isClearing = false // 全局清除锁
            // const clearDebounce = debounce(async () => {
            // if (isClearing) return
            // isClearing = true
            // // 重置vuex、清空标签、跳转登录
            // //  const sjhm=this.state.userInfo.sjhm;
            // //  await this.dispatch('loginOut',{sjhm});
            // this.dispatch("logoutLocalSync");
            // router.replace({
            //     path: '/main/home',
            //     query: {redirect: router.currentRoute.fullPath}
            // });
            // setTimeout(() => { isClearing = false }, 1000)
            // }, 300)

            // window.addEventListener('storage', (e) => {
            // // 检测业务缓存全部清空的标记
            // console.log(e);
            // if (e.key && e.newValue === null && (e.key.startsWith('token')||
            //     e.key.startsWith('userType'))) {
            //     clearDebounce()
            // }
            // })
        if(res.data.code===200){
            // clearDebounce();

            commit('initUserInfo');
            commit('initToken');
            commit('initRecommend');
            commit('initSchoolFind');
            commit('initCollectSchool');
            commit('initLrzyfaList');
            commit("initCompareSchool");
            commit("initUserType");
            commit('initIsUpdateToken');
            commit('initIsShowMsg');
            commit('initYsCollectInfo');

            // commit("setIsLoginOut",{isLoginOut:true});
            // localStorage.clear();
            // logOutHandleStorage();
            // clearAllPage();
            // commit('initYfLoadElement');
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }else if(res.data.code===500){
            if(res.data.message){
                Message.error({message:res.data.message});
            }else if(res.data.msg){
                Message.error(res.data.msg);
            }
        }else if(res.status===401){
            Message.error({message: '登录超时，请重新登录'});
            // clearDebounce();

            commit('initRecommend');
            commit('initSchoolFind');
            commit('initUserInfo');
            commit('initToken');
            commit('initCollectSchool');
            commit('initLrzyfaList');
            commit("initCompareSchool");
            commit("initUserType");
            commit('initIsUpdateToken');
            commit('initIsShowMsg');
            commit('initYsCollectInfo');

            // commit("setIsLoginOut",{isLoginOut:true});
            // localStorage.clear();
            // logOutHandleStorage();
            // clearAllPage();
            // commit('initYfLoadElement');
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
            // clearDebounce();

            commit('initRecommend');
            commit('initSchoolFind');
            commit('initUserInfo');
            commit('initToken');
            commit('initCollectSchool');
            commit('initLrzyfaList');
            commit("initCompareSchool");
            commit("initUserType");
            commit('initIsUpdateToken');
            commit('initIsShowMsg');
            commit('initYsCollectInfo');

            // commit("setIsLoginOut",{isLoginOut:true});
            // localStorage.clear();
            // logOutHandleStorage();
            // clearAllPage();
            // commit('initYfLoadElement');
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            Message.warning({message:"您的账号在其他地点登陆了！",showClose:true});
            // clearDebounce();

            commit('initRecommend');
            commit('initSchoolFind');
            commit('initUserInfo');
            commit('initToken');
            commit('initCollectSchool');
            commit('initLrzyfaList');
            commit("initCompareSchool");
            commit("initUserType");
            commit('initIsUpdateToken');
            commit('initIsShowMsg');
            commit('initYsCollectInfo');
            // commit("setIsLoginOut",{isLoginOut:true});
            // localStorage.clear();
            // logOutHandleStorage();
            // clearAllPage();
            // commit('initYfLoadElement');
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }
},
logoutLocalSync({commit}){
    localStorage.removeItem('whBkTableData');
    localStorage.removeItem('whZkTableData');
    localStorage.removeItem('pc');

            commit('initUserInfo');
            commit('initToken');
            commit('initRecommend');
            commit('initSchoolFind');
            commit('initCollectSchool');
            commit('initLrzyfaList');
            commit("initCompareSchool");
            commit("initUserType");
            commit('initIsUpdateToken');
            commit('initIsShowMsg');
},
testfun(){
    const outFlag=this.state.isLoginOut;
    const storeToken=this.state.token;
    const filterFlag=window.__CANCEL_PERSIST;
    const loginOutCount=window.loginOutCount;
    console.log(storeToken);
    console.log(outFlag);
    console.log(window.__CANCEL_PERSIST);
    if(loginOutCount>0){

        commit('initUserInfo');
        commit('initToken');
        commit('initRecommend');
        commit('initSchoolFind');
        commit('initCollectSchool');
        commit('initLrzyfaList');
        commit("initCompareSchool");
        commit("initUserType");
        commit('initIsUpdateToken');
        commit('initIsShowMsg');
        // localStorage.clear();
        // logOutHandleStorage();
        // clearAllPage();
        // commit('initYfLoadElement');
        commit("initIsLoginOut")
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else{
    }
},
setUserType({commit},{type}){
    commit("setUserType",{type})
},
  //重置院校数据
RestSchoolData({ commit }) {
    commit("initSchool");
},
  //根据用户ID获取用户信息
async initUserInfo({ commit }, yhid) {
// const result = await getUserInfo(yhid);
const result = await module.getUserInfo(yhid);
if (result.data.code === 200) {
      commit("initYshUserInfo", { userInfo: result.data.data });
}else if(result.data.code===500){
    if(result.data.message){
        Message({message:result.data.message,type:'error'});
    }else if(result.data.msg){
      Message({message:result.data.message,type:'error'});
    }
}else if(result.status===401){
    Message({message: '登录超时，请重新登录',type:"error"});
    await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
    router.replace({
        path: '/main/home',
        query: {redirect: router.currentRoute.fullPath}
    });
}else if(result.data.code===0){
    Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
    await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
    router.replace({
        path: '/main/home',
        query: {redirect: router.currentRoute.fullPath}
    });
}else if(result.status===409||result.status===410||result.status===411){
    Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
    await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
    router.replace({
        path: '/main/home',
        query: {redirect: router.currentRoute.fullPath}
    });
} 
},
async Logout({commit}){
    // const result = await logout();
    const result = await module.logout();
    if (result.data.code === 200) {
      commit(resetUserInfo);
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.message,type:'error'});
        }
    }else if(result.status===401){
            Message({message: '登录超时，请重新登录',type:"error"});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
    }else if(result.data.code===0){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
    }else if(result.status===409||result.status===410||result.status===411){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await  this.dispatch('loginOut',{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
    }
},
  //根据用户ID获取用户收藏的院校
async getCollectSchool({ commit }, params) {
    // const result = await getCollectSchool(params);
    const result = await module.getCollectSchool(params);
    console.log(result);
    if (result.data.code === 200) {
        const arr=result.data.data.data.records
        const newQuchongArr=arr.filter((item,index,self)=>index===self.findIndex((obj)=>obj.gb1===item.gb));;
        const newObj={...result.data.data.data};
        newObj.records=newQuchongArr;
        commit("userCollectSchool", { collectSchool: newObj });
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.message,type:'error'});
        }
    }else if(result.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.status===409||result.status===410||result.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }
},
async getCollectSchoolZyz({ commit }, params){
        // const result = await getCollectSchool(params);
    await getApiIndexMethod();
    let result={};
    let result2={};
    if(params.pageNum2&&params.pcStorage=='0'){
     result = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid
        +"/"+params.pageNum2+"/"+params.pcStorage);
     result2 = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid
        +"/"+params.pageNum+"/"+params.pc2);
    }else if(params.pageNum2&&params.pcStorage=='7'){
     result2 = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid
        +"/"+params.pageNum2+"/"+params.pcStorage);
     result = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid
        +"/"+params.pageNum+"/"+params.pc1);
    }else{
     result = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid
        +"/"+params.pageNum+"/"+params.pc1);
     result2 = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid
        +"/"+params.pageNum+"/"+params.pc2);
    }
    console.log(result);
    console.log(result2);
    if (result.data.code === 200&&result2.data.code==200) {
        console.log(result.data.data.data.records);
        const arr=[...result.data.data.data.records]
        const arr2=[...result2.data.data.data.records]
        const newQuchongArr=arr.filter((item,index,self)=>index===self.findIndex((obj)=>obj.gb===item.gb));;
        const newObj={...result.data.data.data};
        const bkYxs=[];
        const zkYxs=[];
        for(let i=0;i<arr.length;i++){
            if(arr[i]&&arr[i].yxmc){
                arr[i].chooseFlag=false;
                for(let j=1;j<7;j++){
                    if(arr[i]['zydh'+j]){
                        arr[i].chooseFlag=true;
                    }
                }
                arr[i].zhcj=this.state.userInfo.equivalent;
            }
        }
        for(let i=0;i<arr2.length;i++){
            if(arr2[i]&&arr2[i].yxmc){
                arr2[i].chooseFlag=false;
                for(let j=1;j<7;j++){
                    if(arr2[i]['zydh'+j]){
                        arr2[i].chooseFlag=true;
                    }
                }
                arr2[i].zhcj=this.state.userInfo.equivalent;
            }
        }
        newObj.records=[];
        newObj.zyzRecords=result.data.data.data.records;
        console.log(arr2);
        if(params.pc1==0){
            newObj.bkZyzRecords=arr;
            newObj.bkPageNum=result.data.data.data.current;
            newObj.bkTotal=result.data.data.data.total;
            newObj.bkSize=result.data.data.data.size;
        }
         if(params.pc2==7){
            newObj.zkZyzRecords=arr2;
            newObj.zkPageNum=result2.data.data.data.current;
            newObj.zkTotal=result2.data.data.data.total;
            newObj.zkSize=result2.data.data.data.size;
        }
        // newObj.bkZyzRecords=bkYxs;
        // newObj.zkZyzRecords=zkYxs;
        // newObj.records=newQuchongArr;
      commit("userCollectSchool", { collectSchool: newObj });
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.message,type:'error'});
        }
    }else if(result.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.status===409||result.status===410||result.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result2.data.code===500){
        if(result2.data.message){
            Message({message:result2.data.message,type:'error'});
        }else if(result2.data.msg){
          Message({message:result2.data.message,type:'error'});
        }
    }else if(result2.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result2.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result2.status===409||result2.status===410||result2.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }
},
async getCollectSchoolZyz11({ commit }, params){
        // const result = await getCollectSchool(params);
    await getApiIndexMethod();
    const result = await http.getHttp("/queryCollegeZyzTableByUid/"+params.uid+"/"+params.pageNum+"");
    console.log(result);
    if (result.data.code === 200) {
        console.log(result.data.data.data.records);
        const arr=result.data.data.data.records
        const newQuchongArr=arr.filter((item,index,self)=>index===self.findIndex((obj)=>obj.gb===item.gb));;
        const newObj={...result.data.data.data};
        const bkYxs=[];
        const zkYxs=[];
        for(let i=0;i<arr.length;i++){
            if(arr[i].pc==0){
                arr[i].sffc='1';
                bkYxs.push(arr[i]);
            }else if(arr[i].pc==7){
                arr[i].sffc='1';
                zkYxs.push(arr[i]);
            }
            
        }
        newObj.records=[];
        newObj.zyzRecords=result.data.data.data.records;
        newObj.bkZyzRecords=bkYxs;
        newObj.zkZyzRecords=zkYxs;
        // newObj.records=newQuchongArr;
      commit("userCollectSchool", { collectSchool: newObj });
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.message,type:'error'});
        }
    }else if(result.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.status===409||result.status===410||result.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }
},
  //根据用户ID 学院序号取消收藏的院校
async removeCollectSchool({ commit }, schools) {
    if (schools) {
    //   const result = await removeCollectSchool(schools);
      const result = await module.removeCollectSchool(schools);
      if (result.data.code === 200) {
        commit(REMOVE_COLLECT_SCHOOL, { schools });
        schools.callback && schools.callback()
      }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.message,type:'error'});
        }
      }else if(result.status===401){
            Message({message: '登录超时，请重新登录',type:"error"});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
      }
    }
},
async removeCollectSchoolZyz({commit},schools){
    if (schools) {
    //   const result = await removeCollectSchool(schools);
    //   const result = await module.removeCollectSchool(schools);
    await getApiIndexMethod();
    const obj=schools.deleteRow?{...schools.deleteRow}:{};
        obj.collegeid=obj.gb||obj.gbdm||obj.collegeid;
        obj.gbdm=obj.gb||obj.gbdm||obj.collegeid;
        obj.id=obj.id;
        obj.lb=obj.lb||obj.zylb;
        obj.pc=obj.pc;
        obj.sb=obj.sb||obj.yxdm;
        obj.szdq=obj.szdq||obj.yxdq;
        obj.uid=this.state.userInfo.yhid;
        for(let i=1;i<7;i++){
            obj['zydh'+i]=null;
        }
        const res=await http.postHttp('/updateYhgzYxZyz',obj);
        if(res.data.code==200){
            
        }else if(res.data.code===500){
        if(res.data.message){
            Message({message:res.data.message,type:'error'});
        }else if(res.data.msg){
          Message({message:res.data.msg,type:'error'});
        }
        }else if(res.status===401){
                Message({message: '登录超时，请重新登录',type:"error"});
                await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
                router.replace({
                    path: '/main/home',
                    query: {redirect: router.currentRoute.fullPath}
                });
        }else if(res.data.code===0){
                Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
                router.replace({
                    path: '/main/home',
                    query: {redirect: router.currentRoute.fullPath}
                });
        }else if(res.status===409||res.status===410||res.status===411){
                Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
                await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
                router.replace({
                    path: '/main/home',
                    query: {redirect: router.currentRoute.fullPath}
                });
        }
         const result=await http.deleteHttp("/deleteUserCollectionYxZyz/"+schools.uid+
      "/"+schools.collegeid+"/"+schools.zyz+"/"+schools.pc+"");
      if (result.data.code === 200) {
        commit(REMOVE_COLLECT_SCHOOL, { schools });
        schools.callback && schools.callback()
      }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.msg,type:'error'});
        }
      }else if(result.status===401){
            Message({message: '登录超时，请重新登录',type:"error"});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
      }else if(result.data.code===0){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
      }else if(result.status===409||result.status===410||result.status===411){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
      }
    }
},
//批量删除用户收藏全部院校
async removeCollegeAll({ commit },params) {
  const {uid,callback } = params;
  if(uid) {
    // const result = await removeCollectSchoolList(params.uid);
    const result = await module.removeCollectSchoolList(params.uid);
    if(result.data.code === 200) {
      commit(REMOVE_COLLECT_SCHOOL_ALL);
      callback && callback();
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.data){
            Message({message:result.data.data,type:'error'});
        } else if(result.data.msg){
          Message({message:result.data.msg,type:'error'});
        }
    }else if(result.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.status===409||result.status===410||result.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    } 
  }
},
async removeCollegeZyzAll({commit},params){
      const {uid,callback } = params;
  if(uid) {
    // const result = await removeCollectSchoolList(params.uid);
    await getApiIndexMethod();
    const arr1=params.list||[];
    const arr2=[];
    for(let i=0;i<arr1.length;i++){
        if(arr2.length>=1){
            let haveFlag=false;
            for(let j=0;j<arr2.length;j++){
                if(arr2[j].yxmc==arr1[i].yxmc&&arr2[j].zyz==arr1[i].zyz){
                    haveFlag=true;
                    break;
                }
            }
            if(!haveFlag){
                arr2.push(arr1[i]);
            }
        }else{
            arr2.push(arr1[i]);
        }
    }
    for(let i=0;i<arr2.length;i++){
        const obj={...arr2[i]};
        obj.collegeid=arr2[i].gb||arr2[i].gbdm||arr2[i].collegeid;
        obj.gbdm=arr2[i].gb||arr2[i].gbdm||arr2[i].collegeid;
        obj.id=arr2[i].id;
        obj.lb=arr2[i].lb||arr2[i].zylb;
        obj.pc=arr2[i].pc;
        obj.sb=arr2[i].sb||arr2[i].yxdm;
        obj.szdq=arr2[i].szdq||obj.yxdq;
        obj.uid=this.state.userInfo.yhid;
        for(let j=1;j<7;j++){
            obj['zydh'+j]=null;
        }
        const res=await http.postHttp("/updateYhgzYxZyz",obj);
        if(res.data.code==200){
            continue;
        }else if(res.data.code===500){
        if(res.data.message){
            Message({message:res.data.message,type:'error'});
        }else if(res.data.msg){
          Message({message:res.data.msg,type:'error'});
        }
        }else if(res.status===401){
            Message({message: '登录超时，请重新登录',type:"error"});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }else if(res.data.code===0){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }else if(res.status===409||res.status===410||res.status===411){
            Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
            await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
            router.replace({
                path: '/main/home',
                query: {redirect: router.currentRoute.fullPath}
            });
        }
    }
    const result = await http.deleteHttp("/deleteAllZyzCollection/"+params.uid+"");
    if(result.data.code === 200) {
      commit(REMOVE_COLLECT_SCHOOL_ALL);
      callback && callback();
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.msg,type:'error'});
        }
    }else if(result.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.status===409||result.status===410||result.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    } 
  }
},
//修改综合分
saveTatalScore({ commit }, totalScore) {
    commit(SAVE_TOTAL_SACORE, { totalScore });
},
async getSchoolQuery({ commit }, params){
    // const result = await getSchoosFinder(params.artSchool);
    const result = await module.getSchoosFinder(params.artSchool);
    console.log(result);
    if (result.data.code === 200) {
        const obj={...result.data.data};
        const data=obj.data.records?[...obj.data.records]:[];
        for(let i=0;i<data.length;i++){
            if(data[i].yxmc){
                data[i].createPc=-1;
                if(params.artSchool.condition==3
                    ||!(params.artSchool.condition)){
                    data[i].createPc=0;
                }else if(params.artSchool.condition==8){
                    data[i].createPc=7;
                }
                data[i].isCanDisabled=false;
                data[i].isShowZyzDetail=false;
                data[i].allZyz=[];
                data[i].inputSbVisible=false;
                data[i].writeSb='';
                data[i].submitSb='';
            }
        }
        obj.data.records=data;
      commit(SCHOOL_FINDER_DATA, { schoolData: {...obj} });
      params.callback && params.callback();
    }else if(result.data.code===500){
        if(result.data.message){
            Message({message:result.data.message,type:'error'});
        }else if(result.data.msg){
          Message({message:result.data.message,type:'error'});
        }
    }else if(result.status===401){
        Message({message: '登录超时，请重新登录',type:"error"});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.data.code===0){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }else if(result.status===409||result.status===410||result.status===411){
        Message({message:"您的账号在其他地点登陆了！",showClose:true,type:'warning'});
        await this.dispatch("loginOut",{sjhm:this.state.userInfo.phone});
        router.replace({
            path: '/main/home',
            query: {redirect: router.currentRoute.fullPath}
        });
    }
}
};
